<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
          <FournisseurAddModal v-on:fournisseuradded="reloadData" ></FournisseurAddModal>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <transition name="fade">
        <div  v-if="ImpossibleAddFournisseur" 
              class="alert alert-danger" 
              role="alert">
          Impossible de supprimer ce fournisseur
        </div>
      </transition>
      <div class="col-lg-3 float-right">
        <base-input alternative=""
                    placeholder="Rechercher"
                    input-classes="form-control-alternative input_search"
                    v-model="search"
                    @change="searchData"
        />
      </div>
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="data"
                  :columns="columns"
                  :sortKey.sync="sortKey"
                  :reverse.sync="reverse"
                  @KeyChanged="reloadDataSorted"
                  @reverse="reverseChange"
                  @sortKey="sortKeyChange">
        <template slot="columns">
        </template>

        <template slot-scope="{row}">
          <td>
            {{row.idFournisseur}}
          </td>
          <td>
            {{row.nom}}
          </td>
          <td>
            {{row.prenomContact}} {{row.nomContact}}
          </td>
          <td>
            <a :href="'mailto:' + row.emailContact">{{row.emailContact}}</a>
          </td>
          <td>
            <a :href="'tel:' + row.phoneContact">{{row.phoneContact}}</a>
          </td>
          <td>
            <div class="row">
              <FournisseurEditModal v-bind:fournisseur="row"></FournisseurEditModal>&nbsp;&nbsp;&nbsp;
              <a @click.prevent="deleteFournisseur($event, row.idFournisseur)" href="#"><i class="fa fa-trash-alt"></i></a>
            </div>
          </td>
        </template>

      </base-table>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
        <base-pagination 
            :total="total"
            :perPage="perPage"
            @input="changeData"
            ></base-pagination>
    </div>

  </div>
</template>
<script>
  import constvar from '@/const'
  import _ from 'lodash'
  import router from '@/router'
  import FournisseurAddModal from '@/components/FournisseurAddModal'
  import FournisseurEditModal from '@/components/FournisseurEditModal'

  export default {
    name: 'fournisseur-table',
    components: {
      FournisseurAddModal,
      FournisseurEditModal
    },
    props: {
      type: {
        type: String
      },
      title: String
    },
    data() {
      return { 
        total: 0,
        alldata: [],
        data: [],
        perPage: 10,
        value: 1,
        sortKey: 'idFournisseur',
        reverse: true,
        search: '',
        columns: [
          ['idFournisseur','ID'],
          ['nom','Nom'],
          ['prenomContact','Contact'],
          ['emailContact','email'],
          ['phoneContact','Téléphone'],
          ['','']
          ],
        ImpossibleAddFournisseur: false,
      }
    },
    computed: {
      alldata_filtered: function() { 
        if(this.search != '') {
          return this.alldata.filter(({idFournisseur, nom, emailContact, prenomContact, nomContact, phoneContact}) => idFournisseur == this.search || nom.toLowerCase().includes(this.search.toLowerCase()) || emailContact.toLowerCase().includes(this.search.toLowerCase()) || prenomContact.toLowerCase().includes(this.search.toLowerCase()) || nomContact.toLowerCase().includes(this.search.toLowerCase()) || phoneContact.toLowerCase().includes(this.search.toLowerCase()));
        } else {
          return this.alldata;
        }
      }
    },
    async created() {
        const response = await fetch(constvar.api_url+'fournisseur', {
        method: 'GET',
        credentials: 'include',
        });
        if(response.ok) { 
            const json = await response.json();
            //check if api return regenerated token
            if(json.code != 409) {
                this.alldata = json;
                this.changeData(1);
                this.total = this.alldata_filtered.length;
            } else { 
                router.push("login")    
            }
        }
    },
    methods: {
        sortTableData: function() {
          this.alldata.forEach(function(element) {
            element.idFournisseur = Number(element.idFournisseur);
          })
          return _.orderBy(this.alldata_filtered, this.sortKey, (this.reverse) ? 'desc' : 'asc')
        },
        changeData: function(e) {
            let page = e;
            let perPage = this.perPage;
            let from = (page * perPage) - perPage;
            let to = (page * perPage);
            let tableData = this.sortTableData();
            this.data = tableData.slice(from, to);
            this.value = page;
        },
        reloadDataSorted: function() {
          this.changeData(this.value);
        },
        sortKeyChange: function(e) {
          this.sortKey = e;
        },
        reverseChange: function(e) {
          this.reverse = e;
        },
        searchData: function() {
        },
        reloadData: async function() {
          const response = await fetch(constvar.api_url+'fournisseur', {
          method: 'GET',
          credentials: 'include',
          });
          if(response.ok) { 
              const json = await response.json();
              //check if api return regenerated token
              if(json.code != 409) {
                  this.alldata = json;
                  this.changeData(1)
                  this.total = this.data.length;
              } else { 
                  router.push("login")    
              }
          } 
        },
        deleteFournisseur: async function(event, idFournisseur) {
          var self = this;
          let options = {
              okText: 'Confirmer',
              cancelText: 'Annuler',
          };
          this.$dialog
          .confirm('Êtes vous sûr de vouloir supprimer ce fournisseur ?', options)
          .then(async function() {
            const response = await fetch(constvar.api_url+'fournisseur/'+idFournisseur, {
            method: 'DELETE',
            credentials: 'include',
            });
            if(response.ok) { 
                const json = await response.json();
                //check if api return regenerated token
                if(json.rows == 1) {
                    self.reloadData();
                } else if(json.rows == -1) {
                    self.ImpossibleAddFournisseur = true
                    setTimeout(()=>{
                      self.ImpossibleAddFournisseur = false
                    },1500);
                } else { 
                    router.push("login")    
                }
            } 
          })
        },
    },
    watch: {
      alldata_filtered: function() {
        this.changeData(this.value);
      }
    },
  }
</script>
<style>
</style>
